/**
 * @generated SignedSource<<46839b7e97ab6312edeb60457a41c273>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedYMAL_buyPageItemRecommendations$data = {
  readonly youMayAlsoLike: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_item">;
  } | null> | null;
  readonly " $fragmentType": "SharedYMAL_buyPageItemRecommendations";
};
export type SharedYMAL_buyPageItemRecommendations$key = {
  readonly " $data"?: SharedYMAL_buyPageItemRecommendations$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedYMAL_buyPageItemRecommendations">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedYMAL_buyPageItemRecommendations",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "youMayAlsoLike",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedRelatedItemsSection_item"
        }
      ],
      "storageKey": "youMayAlsoLike(first:20)"
    }
  ],
  "type": "BuyPageItemRecommendations",
  "abstractKey": null
};

(node as any).hash = "300c48b2a9b3632583d0a4480ee84e03";

export default node;
